export default __webpack_public_path__ + "media/images/icon_mutes-7d562e2ae2a2e36d206236897259687e.png";